<template>
  <div class="container">
    <div class="survey-title mb40 has-text-centered">How do you <span
        class="highlight-text">identify</span>?</div>
    <div class="fields-block mb60">
      <h3 class="title has-text-centered">Please select one.</h3>
      <div class="columns justify-content-center">
        <div class="column">
          <div class="field is-grouped is-flex-tablet justify-content-center align-items-center">
            <div class="control pref-block mr5 ml5 has-text-centered">
              <input v-model="gender" value="Female" class="is-checkradio is-block" id="pref-gender-female" type="radio"
                name="pref-gender">
              <label for="pref-gender-female"
                class="is-flex is-flex-column align-items-center justify-content-center">
                <img src="@/assets/img/icon-male.svg" alt="" class="mb10">
                <h4 class="pref-label">Female</h4>
              </label>
            </div>
            <div class="control pref-block mr5 ml5 has-text-centered">
              <input v-model="gender" value="Male" class="is-checkradio is-block" id="pref-gender-male" type="radio"
                name="pref-gender">
              <label for="pref-gender-male"
                class="is-flex is-flex-column align-items-center justify-content-center">
                 <img src="@/assets/img/icon-female.svg" alt="" class="mb10">
                <h4 class="pref-label">Male</h4>
              </label>
            </div>
            <div class="control pref-block mr5 ml5 has-text-centered">
              <input v-model="gender" value="Other" class="is-checkradio is-block" id="pref-gender-other" type="radio"
                name="pref-gender">
              <label for="pref-gender-other"
                class="is-flex is-flex-column align-items-center justify-content-center">
                <img src="@/assets/img/icon-other.svg" alt="" class="mb10">
                <h4 class="pref-label">Other</h4>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="steps mt100 mb50">
      <ul class="is-flex justify-content-around">
        <li class="is-active"></li>
        <li class="is-active"></li>
        <li class=""></li>
        <li class=""></li>
        <li class=""></li>
        <li class=""></li>
        <li class="mr0"></li>
      </ul>
    </div>
    <div class="next-button is-flex align-items-center justify-content-center has-text-centered mb50">
      <a href="#" @click.prevent="back()"
        class="back-btn is-primary is-hidden-mobile mr40 m0-xs">Back</a>
      <a href="#" @click.prevent="next()" class="button is-primary ml40 is-marginless-tablet">Next</a>
    </div>
    <div
      class="skip-button is-flex-mobile align-items-center justify-content-between has-text-centered mb30">
      <a @click.prevent="back()" class="back-btn is-primary is-hidden-tablet">Back</a>
      <a @click.prevent="setStep(3)" class="is-primary">Skip</a>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      gender: '',
    };
  },
  computed: {
    ...mapGetters({
      step: "usersurvey/step"
    })
  },
  methods: {
    /**
     * Step back
     */
    back() {
      this.setStep(1);
      this.setSurvey({
        relationship: '',
      })
    },

    /**
     * Next step 
     */
    next() {
      if(this.gender == '') {
        this.setSnackbar({
          modal: true,
          message: 'Please identify yourself.',
          type: 'warning',
        }) 
      } else {
        this.setSurvey({
          gender: this.gender
        })
        this.setStep(3);
      }
    },
    ...mapActions({
      setSnackbar: "snackbar/setSnackbar",
      setStep: "usersurvey/setStep",
      setSurvey: "usersurvey/setSurvey"
    })
  },
};
</script>